import React from 'react';
import PropTypes from 'prop-types';
import DownloadIcon from '@icons/download-icon';
import { downloadAttachment } from './actions';
import './button.scss';

const DownloadButton = ({
  attachment
}) => {
  const downloadAction = () => {
    downloadAttachment(attachment);
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      downloadAction();
    }
  };

  return (
    <div
      onClick={downloadAction}
      onKeyDown={handleKeyDown}
      styleName="action-icon"
      role="button"
      tabIndex={0}
      aria-label="Download attachment"
    >
      <DownloadIcon />
    </div>
  );
};

DownloadButton.propTypes = {
  attachment: PropTypes.object
};

export default DownloadButton;
